import { useState, useEffect } from "react";
import { injectIntl } from "react-intl";

const UITypeSelect = (props) => {
  const { sport, value, onChange, changed, intl } = props;
  const { formatMessage } = intl;
  const [options, setOptions] = useState([]);

  const createOption = (value, translation, text) => {
    return (
      <option key={value} value={value}>
        {formatMessage({
          id: translation,
          defaultMessage: text,
        })}
      </option>
    );
  };

  useEffect(() => {
    if (sport === "basketball") {
      setOptions([
        createOption("lite", "basketball.ui.lite", "Synergy Stats Lite"),
        createOption("standard", "basketball.ui.standard", "Synergy Stats"),
      ]);
    } else if (sport === "handball") {
      setOptions([createOption("standard", "handball.ui.standard", "Synergy Stats")]);
    } else if (sport === "hockey") {
      setOptions([
        createOption("outdoor", "hockey.ui.outdoor", "Outdoor Field Hockey"),
        createOption("indoor", "hockey.ui.indoor", "Indoor Field Hockey"),
        createOption("hockey5s", "hockey.ui.5s", "Hockey 5s"),
      ]);
    } else {
      setOptions([createOption("standard", "sport.ui.standard", "Synergy Stats")]);
    }
  }, [sport]);

  return (
    options && (
      <select
        type="text"
        disabled={sport === "hockey"}
        onChange={(e) => {
          onChange && onChange(e.target.value);
        }}
        style={changed ? { border: "2px solid green" } : {}}
        value={value}
      >
        {sport === "hockey" ? (
          <option key="not_available" value="not_available">
            {formatMessage({
              id: "hockey.not_available",
              defaultMessage: "Not available",
            })}
          </option>
        ) : (
          <>{...options}</>
        )}
      </select>
    )
  );
};

export default injectIntl(UITypeSelect);
